import Vue from 'vue'
import { format } from 'date-fns'
import { ValidationObserver, ValidationProvider, extend, setInteractionMode } from 'vee-validate'
import { alpha, email, is, is_not, length, max, min, regex, required } from 'vee-validate/dist/rules'

setInteractionMode('eager') // aggressive, eager, lazy, passive

// Imported rules
extend('alpha', alpha)
extend('email', email)
extend('is', is)
extend('is_not', is_not)
extend('length', {
  ...length,
  params: ['length'],
  message: '{_field_} must be exactly {length} characters.',
})
extend('max', {
  ...max,
  params: ['length'],
  message: '{_field_} may not be greater than {length} characters.',
})
extend('min', min)
extend('regex', regex)
extend('required', {
  ...required,
  message: '{_field_} is required.',
})

// Custom rules
extend('is_unique', {
  params: ['values'],
  validate(newVal, { values }) {
    return values.filter(value => value === newVal).length < 2
  },
})
extend('is_past_date', {
  params: [],
  validate(dateStr) {
    return dateStr < format(new Date(), 'yyyy-MM-dd')
  },
})
//restrict user to select only 3 nmis
extend('maxthreeonly', {
  params: ['values'],
  validate(values) {
    if (values.length > 3) {
      return false
    }
    return true
  },
  message: 'Please select only 3 NMIs.',
})

//restrict user to select only 10 nmis
extend('maxtenonly', {
  params: ['values'],
  validate(values) {
    if (values.length > 10) {
      return false
    }
    return true
  },
  message: 'Please select only 10 NMIs.',
})

extend('two_dates', {
  params: ['values'],
  validate(values) {
    if (values.split(' – ').length != 2) {
      return false
    }
    return true
  },
  message: 'Please select two dates',
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
